import { render } from "./CIS-Footer-SocialLink.vue?vue&type=template&id=47cb94b8"
import script from "./CIS-Footer-SocialLink.vue?vue&type=script&lang=js"
export * from "./CIS-Footer-SocialLink.vue?vue&type=script&lang=js"

import "./CIS-Footer-SocialLink.vue?vue&type=style&index=0&id=47cb94b8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__